import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = async () => {
    try {
      setLoading(true);
      const url = `${API_BASE_URL}/api/cars?limit=100&sortBy=createdAt&sortOrder=desc`;
      console.log('🔍 Fetching from URL:', url);
      
      const response = await fetch(url);
      
      console.log('📡 Response status:', response.status);
      console.log('📡 Response OK:', response.ok);
      
      if (!response.ok) {
        throw new Error('Eroare la încărcarea mașinilor');
      }

      const data = await response.json();
      
      console.log('📦 Full API Response:', data);
      console.log('✅ Success field:', data.success);
      console.log('📊 Data field type:', typeof data.data);
      console.log('📊 Data field:', data.data);
      console.log('📊 Is array?:', Array.isArray(data.data));
      
      if (data.success) {
        if (Array.isArray(data.data)) {
          console.log('✅ Cars loaded successfully:', data.data.length, 'cars');
          if (data.data.length > 0) {
            console.log('🚗 First car:', data.data[0]);
            console.log('🖼️ First car images:', {
              imagineaPrincipala: data.data[0].imagineaPrincipala,
              imagini: data.data[0].imagini
            });
          }
          setCars(data.data);
        } else {
          console.error('❌ data.data is not an array!', data.data);
          setError('Răspuns invalid de la server - datele nu sunt un array');
        }
      } else {
        console.error('❌ API returned success: false');
        setError('API a returnat success: false');
      }
    } catch (err) {
      setError(err.message);
      console.error('❌ Error fetching cars:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/cars/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error('Eroare la ștergerea mașinii');
      }

      const data = await response.json();
      
      if (data.success) {
        setCars(cars.filter(car => car._id !== id));
        setDeleteConfirm(null);
        alert('Mașina a fost ștearsă cu succes!');
      }
    } catch (err) {
      alert('Eroare la ștergerea mașinii: ' + err.message);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  const getCarImage = (car) => {
    // Check if imagineaPrincipala exists
    if (car.imagineaPrincipala) {
      // If it's already a full URL, use it directly
      if (car.imagineaPrincipala.startsWith('http')) {
        return car.imagineaPrincipala;
      }
      // If it starts with /, prepend API_BASE_URL
      return `${API_BASE_URL}${car.imagineaPrincipala}`;
    }
    
    // Check if imagini array exists and has items
    if (car.imagini && car.imagini.length > 0) {
      const firstImage = car.imagini[0];
      // If it's already a full URL, use it directly
      if (firstImage.startsWith('http')) {
        return firstImage;
      }
      // If it starts with /, prepend API_BASE_URL
      return `${API_BASE_URL}${firstImage}`;
    }
    
    // Fallback to placeholder
    return 'https://via.placeholder.com/150x100?text=No+Image';
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('ro-RO').format(price);
  };

  const formatKilometraj = (km) => {
    return new Intl.NumberFormat('ro-RO').format(km);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('ro-RO', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Se încarcă mașinile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
        <h3>Eroare</h3>
        <p>{error}</p>
        <button onClick={fetchCars} className="retry-btn">Încearcă din nou</button>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div>
          <h1>Dashboard Admin</h1>
          <p>Gestionează parcul auto</p>
        </div>
        <div className="header-actions">
          <button className="add-car-btn" onClick={() => navigate('/admin/masini/nou')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" 
                    strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Adaugă mașină
          </button>
          <button className="logout-btn" onClick={handleLogout}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Ieșire
          </button>
        </div>
      </div>

      <div className="dashboard-stats">
        <div className="stat-card">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" 
                  stroke="currentColor" strokeWidth="2"/>
            <path d="M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" 
                  stroke="currentColor" strokeWidth="2"/>
          </svg>
          <div>
            <span className="stat-value">{cars.length}</span>
            <span className="stat-label">Total mașini</span>
          </div>
        </div>

        <div className="stat-card">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 6v6l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <div>
            <span className="stat-value">
              {cars.filter(car => car.disponibilitate === 'Avem pe stoc').length}
            </span>
            <span className="stat-label">Pe stoc</span>
          </div>
        </div>

        <div className="stat-card">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div>
            <span className="stat-value">
              {formatPrice(cars.reduce((sum, car) => sum + car.pret, 0))}
            </span>
            <span className="stat-label">Valoare totală (EUR)</span>
          </div>
        </div>
      </div>

      <div className="cars-table-container">
        <table className="cars-table">
          <thead>
            <tr>
              <th>Imagine</th>
              <th>Mașină</th>
              <th>Preț</th>
              <th>Kilometraj</th>
              <th>An</th>
              <th>Poze</th>
              <th>Stare</th>
              <th>Adăugat</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {cars.map(car => (
              <tr key={car._id}>
                <td>
                  <img 
                    src={getCarImage(car)}
                    alt={`${car.marca} ${car.model}`}
                    className="table-car-image"
                    onError={(e) => {
                      console.error('Image load error for car:', car._id, car.marca, car.model);
                      console.error('Attempted URL:', e.target.src);
                      e.target.src = 'https://via.placeholder.com/150x100?text=No+Image';
                    }}
                  />
                </td>
                <td>
                  <div className="car-info">
                    <span className="car-name">{car.marca} {car.model}</span>
                    <span className="car-details">{car.transmisie} • {car.carburant}</span>
                  </div>
                </td>
                <td>
                  <span className="price-value">{formatPrice(car.pret)} EUR</span>
                </td>
                <td>{formatKilometraj(car.kilometraj)} km</td>
                <td>{car.anFabricatie}</td>
                <td>
                  <span className={`image-count-badge ${(car.imagini?.length || 0) >= 10 ? 'many' : 'few'}`}>
                    📷 {car.imagini?.length || 0}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${car.disponibilitate === 'Avem pe stoc' ? 'in-stock' : 'out-stock'}`}>
                    {car.disponibilitate}
                  </span>
                </td>
                <td>{formatDate(car.createdAt)}</td>
                <td>
                  <div className="action-buttons">
                    <button 
                      className="action-btn view"
                      onClick={() => navigate(`/masini/${car.slug || car._id}`)}
                      title="Vizualizează"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" 
                              stroke="currentColor" strokeWidth="2"/>
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </button>
                    
                    {/* ⭐ BUTON NOU: Adaugă imagini rapid */}
                    <button 
                      className="action-btn add-images"
                      onClick={() => navigate(`/admin/masini/edit/${car._id}`, { state: { addImagesOnly: true } })}
                      title={`Adaugă imagini (${car.imagini?.length || 0}/50)`}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                        <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                        <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M14 3v4M12 5h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                    
                    <button 
                      className="action-btn edit"
                      onClick={() => navigate(`/admin/masini/edit/${car._id}`)}
                      title="Editează"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" 
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" 
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                    <button 
                      className="action-btn delete"
                      onClick={() => setDeleteConfirm(car)}
                      title="Șterge"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" 
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon delete-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Confirmare ștergere</h3>
            <p>
              Ești sigur că vrei să ștergi <strong>{deleteConfirm.marca} {deleteConfirm.model}</strong>?
              <br />
              Această acțiune nu poate fi anulată.
            </p>
            <div className="modal-actions">
              <button className="modal-btn cancel" onClick={() => setDeleteConfirm(null)}>
                Anulează
              </button>
              <button className="modal-btn confirm" onClick={() => handleDelete(deleteConfirm._id)}>
                Șterge mașina
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;